import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { ThreeDotsLoader } from '../../assets/icons/ThreeDotsLoader'
import './TopLoader.scss'
const rootClassName = 'component-top-loader'

interface TopLoaderProps {
  opened?: boolean
  logo?: React.ReactNode
  status?: string | React.ReactNode
}

export default function TopLoader(props: TopLoaderProps) {
  return (
    <CSSTransition
      classNames='fade'
      timeout={300}
      in={props.opened}
      unmountOnExit
    >
      <div className={rootClassName}>
        <div className={`${rootClassName}-logo`}>{props.logo}</div>
        {props.status && (
          <div className={`${rootClassName}-status`}>{props.status}</div>
        )}
      </div>
    </CSSTransition>
  )
}

TopLoader.defaultProps = {
  logo: <ThreeDotsLoader theme='secondary' />
}
